import {Addchart} from '@mui/icons-material'
import i18n from 'i18next';

// ==============================|| DASHBOARD MENU ITEMS ||============================== //


const getTaskManagement = () => ({
    id: 'tasklistManagement',
    type: 'group',
    children: [
        {
            id: 'tasklistManagement',
            title: i18n.t('sidemenu.taskManagement'),
            type: 'item',
            url: '/tasklistManagement',
            icon: Addchart,
            breadcrumbs: false,
        },
    ]
});

export default getTaskManagement;
